import React from "react";
import TradingViewChart from "./components/TradingViewChart";
import RiskManagementTool from "./components/RiskManagementTool";

const App = () => {
  return (
    <div style={{ height: "100vh" }}>
      {/* Other components */}
      {/* <TradingViewChart /> */}
      <RiskManagementTool />

      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        Chris.M
      </div>
    </div>
  );
};

export default App;
